import SystemConfig, {CONFIG_PARAMS} from "./SystemConfig";
import events from "../events/EventsObservable";
import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import IEventObserver from "../events/IEventObserver";
import {REELS_EVENTS} from "../game/slot/reelsEvents";
import EngineDebug from "../engine/EngineDebug";

// @ts-ignore
const __GAME_NS__ = window.__kajotGame__ || "__GAME__";

interface gameAPI {
    debug;
}

interface debugAPI {
    reelsDebug(b:boolean);
    walletDebug(b:boolean);
}

@injectable()
export default class SystemDebug implements IEventObserver {

    private config: SystemConfig;

    private engineDebug: EngineDebug;

    public dbgReels: boolean = false;
    public dbgWallet: boolean = false;

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.EngineDebug) engineDebug: EngineDebug
    ) {
        this.config = config;
        this.engineDebug = engineDebug;

        events.subscribe([
            REELS_EVENTS.REELS_START,
            REELS_EVENTS.REELS_COMPLETE,
        ], this);

        let debugAPI: debugAPI = {
            ["reelsDebug"]: (bool:boolean) => {
                this.dbgReels = !!bool;
            },
            ["walletDebug"]: (bool:boolean) => {
                this.dbgWallet = !!bool;
            }
        };

        // @ts-ignore
        let gameAPI: gameAPI = window[__GAME_NS__] = window[__GAME_NS__] || {};
        gameAPI["debug"] = debugAPI;


        if(this.config.get(CONFIG_PARAMS.DEBUG)) {
            debugAPI.reelsDebug(true);
            // debugAPI.walletDebug(true);
        }
    }

    init() {
        // if(this.config.get(CONFIG_PARAMS.DEBUG)) {
        //     this.activate(true);
        // }
    }

    notify(eventName, data) {
        switch(eventName) {
            case REELS_EVENTS.REELS_START:
                this._spinStart();
                break;

            case REELS_EVENTS.REELS_COMPLETE:
                this._spinEnd();
                break;
        }

    }

    _spinStart() {
        if(!this.dbgReels) return;
        console.time("spin");
    }

    _spinEnd() {
        if(!this.dbgReels) return;
        console.timeEnd("spin");
    }
}
